<div class="row" *ngIf="currentSchoolYearEventsData.length && selectedMonth">
    <div class="col-lg-4">
        <div *ngFor="let month of currentSchoolYearEventsData">
            <div class="month-events" (click)="selectMonth(month.month)">
                <span>{{ month.monthName | translate }} {{ month.month < 7 ? schoolYear.end_year : schoolYear.start_year }}</span>

                <span [ngClass]="'status status__' + month.status" class="text-center"
                    >{{ 'ENUM.MONTH-EVENTS-STATUS.' + month.status.toUpperCase() | translate }}
                </span>
            </div>
        </div>
    </div>

    <div class="col-lg-8" #calendarContainer>
        <ng-content></ng-content>
        <div
            class="buttons-container alone"
            *appCheckPermissions="
                eventsType === eventsTypesEnum.MEAL
                    ? permissions.meals_booking_employees
                    : eventsType === eventsTypesEnum.HOMEWORK
                    ? permissions.homework_school_booking_employees
                    : permissions.events_booking_employees
            "
        >
            <app-generic-button
                (buttonClick)="confirmDisableMonth(selectedMonth)"
                [classes]="'btn btn--primary post-btn'"
                [disabled]="selectedMonth.meals?.length === 0 || selectedMonth.homeworkSchool?.length === 0"
                [inputText]="'SHOP.SHARED.EVENTS.DISABLE_MONTH.DISABLE_BTN'"
            >
            </app-generic-button>
        </div>
    </div>
</div>
